import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode temporarily disabled due to Recharts compatibility issues
// causing DOM manipulation errors (removeChild/insertBefore)
root.render(
  <App />
);
